import { render, staticRenderFns } from "./GeneralConsent.vue?vue&type=template&id=33799662&scoped=true&"
import script from "./GeneralConsent.vue?vue&type=script&lang=js&"
export * from "./GeneralConsent.vue?vue&type=script&lang=js&"
import style0 from "./GeneralConsent.vue?vue&type=style&index=0&id=33799662&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33799662",
  null
  
)

export default component.exports